export var SystemBridgeEventNotification;
(function (SystemBridgeEventNotification) {
    SystemBridgeEventNotification["SYSTEM_UPDATED"] = "systemUpdated";
})(SystemBridgeEventNotification || (SystemBridgeEventNotification = {}));
